import React, { useEffect, useRef } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Experience from './components/Experience';
import Projects from './components/Projects';
import Skills from './components/Skills';
import Education from './components/Education';
import Contact from './components/Contact';
import Achievements from './components/Achievements';
import './index.css';

const App = () => {
  const neuralNetRef = useRef(null);

  useEffect(() => {
    const canvas = neuralNetRef.current;
    const ctx = canvas.getContext('2d');

    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = document.documentElement.scrollHeight;
    };

    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    const particles = [];
    const particleCount = Math.floor((canvas.width * canvas.height) / 10000); // Adjust particle count based on canvas size

    for (let i = 0; i < particleCount; i++) {
      particles.push({
        x: Math.random() * canvas.width,
        y: Math.random() * canvas.height,
        radius: Math.random() * 2 + 1,
        speed: Math.random() * 0.5 + 0.1,
      });
    }

    function animate() {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.fillStyle = 'rgba(200, 200, 255, 0.5)';
      ctx.strokeStyle = 'rgba(100, 100, 255, 0.1)';

      particles.forEach((particle, index) => {
        particle.y -= particle.speed;
        if (particle.y < 0) {
          particle.y = canvas.height;
        }

        ctx.beginPath();
        ctx.arc(particle.x, particle.y, particle.radius, 0, Math.PI * 2);
        ctx.fill();

        for (let j = index + 1; j < particles.length; j++) {
          const dx = particles[j].x - particle.x;
          const dy = particles[j].y - particle.y;
          const distance = Math.sqrt(dx * dx + dy * dy);

          if (distance < 100) {
            ctx.beginPath();
            ctx.moveTo(particle.x, particle.y);
            ctx.lineTo(particles[j].x, particles[j].y);
            ctx.stroke();
          }
        }
      });

      requestAnimationFrame(animate);
    }

    animate();

    return () => {
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <div className="relative bg-gray-900 text-white">
      <canvas ref={neuralNetRef} className="fixed inset-0 z-0" />
      <Header className="fixed top-0 w-full z-20 bg-gray-900" /> {/* Fix the header at the top */}
      <AnimatePresence>
        <motion.div 
          className="relative z-10 container mx-auto px-4 py-16 pt-32" // Add padding-top to avoid overlap
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
        >
          <header className="text-center mb-16">
            <motion.div 
              className="text-xl text-blue-300"
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <Hero/>
            </motion.div>
          </header>
          <main>
            <section className="mb-16">
              <About />
            </section>
            <section className="mb-16">
              <Education />
            </section>
            <section className="mb-16">
              <Experience />
            </section>
            <section className="mb-16">
              <Skills/>
            </section>
            <section className="mb-16">
              <Projects />
            </section>
            <section className="mb-16">
              <Achievements />
            </section>
          </main>
          <footer className="text-center">
            <Contact/>
          </footer>
        </motion.div>
      </AnimatePresence>
    </div>
  );
};

export default App;
